import SchemaError from './utils/SchemaError';
import { SchemaErrorCode } from './utils/type';
import { isIOS, isWeb } from './utils/platform';
let commonSchema;
let validator;
const schemaDic = {};
export function validate(schemaID, data = {}, schemeType, refKey) {
    if (!validator) {
        const Validator = require('jsonschema').Validator; // eslint-disable-line
        validator = new Validator();
    }
    if (!commonSchema) {
        commonSchema = require('./schema/common.json'); // eslint-disable-line
        let events = commonSchema.definitions.common.properties.events.items.oneOf;
        events = events.filter((event) => {
            const { platform, host } = event;
            let supportPlatfrom = true;
            // 如果没有platfrom字段,则表示IOS和Android都支持
            if (platform) {
                supportPlatfrom = isIOS ? platform === 'IOS' : platform === 'Android';
            }
            // 如果没有host字段,则表示Web和RN都支持
            let supportHost = true;
            if (host) {
                supportHost = isWeb ? host === 'Web' : host === 'RN';
            }
            return supportPlatfrom && supportHost;
        });
        commonSchema.definitions.common.properties.events.items.oneOf = events;
    }
    if (!schemaDic[schemaID]) {
        const schema = require('./schema/' + `${schemeType}/${schemaID}` + '.schema.json'); // eslint-disable-line
        // 第一次加载的时候，需要手动把schema的ref解析出来
        const { properties = {} } = schema;
        const { res = {} } = properties;
        const { properties: resProperties = {} } = res;
        const { value = {}, message = {}, result = {} } = resProperties;
        const newRes = {};
        if (value?.$ref) {
            const ref = value.$ref;
            const refArray = ref.split('/');
            const end = refArray.pop();
            newRes.value = commonSchema.definitions.common.properties[end];
        }
        if (message?.$ref) {
            newRes.message = commonSchema.definitions.common.properties.message;
        }
        if (result?.$ref) {
            newRes.result = commonSchema.definitions.common.properties.result;
        }
        // 如果res有值,则做相应的merge
        if (Object.keys(resProperties).length > 0) {
            schema.properties.res.properties = Object.assign(schema.properties.res.properties, newRes);
        }
        // 把解析好以后的schema添加到validator里
        validator.addSchema(schema, `/${schemaID}`);
        schemaDic[schemaID] = schema;
    }
    const currentSchema = schemaDic[schemaID];
    const supportRefKey = currentSchema?.properties?.[refKey];
    if (!supportRefKey) {
        // schema没有args或者res,同时对应的value是有值, schema和value不一致直接抛出错误
        if (Object.keys(data).length > 0) {
            throw new SchemaError(SchemaErrorCode.Validate, `${refKey} need to be empty`);
        }
        // schema没有args或者res,同时对应的value是nil, schema和value一致则直接返回
        return;
    }
    const validateResult = validator.validate(data, {
        $ref: `${schemaID}#/properties/${refKey}`,
    });
    // 校验失败，数据不符合预期， 此处应该进行 前端异常上报， 如 sentry 之类的
    if (!validateResult.valid) {
        const errorMessage = {};
        validateResult.errors.forEach((item, index) => {
            const title = `错误${index}:${item.message ? item.message : item.toString()}`;
            errorMessage[`error${index}`] = title;
        });
        const message = {
            errorMessage,
            schema: validateResult.schema,
            response: validateResult.instance,
        };
        console.warn('返回值校验不通过，errors======>', JSON.stringify(message)); // eslint-disable-line
        throw new SchemaError(SchemaErrorCode.Validate, `${JSON.stringify(message)}`);
    }
}
